/**
 * The caller's own organization, `GET /organizations/me`.
 *
 * It lives in its own file because the top bar's organization menu reads the
 * same cache entry as the page: importing the key from the page would pull the
 * whole lazy page into the shell's bundle.
 */
export const MY_ORGANIZATION_KEY = ['organizations', 'me'] as const;
